export default __webpack_public_path__ + "static/media/new-feature-badge.b23324f1.svg";